import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import withClickOutsideHOC from "@common/hocs/withClickOutside";
import classnames from "classnames";
import * as React from "react";
import { getWidgetDataAttributes } from "../lib";
import Logo from "./Logo/container";
import Menu from "./Menu/container";
import SocialIcons from "./SocialIcons/container";
import UserLogin from "./UserLogin/container";

import "./style.less";

export const INVISIBLE_PROPS: MapProps & WithIsVisibleHOCProps = {
  className: "",
  contentClassName: "",
  isToggled: false,
  isVisible: false,
  contentStyle: {},
  style: {}
};

export interface MapProps {
  isToggled: boolean;
  className: string;
  contentClassName: string;
  contentStyle: React.CSSProperties;
  style: React.CSSProperties;
}

export interface ActionProps {
  hideSidePanel: () => any;
  onDoubleClick?: () => void;
}

type Props = ActionProps & MapProps;
const SidePanel = (props: Props) => {
  const { className, contentClassName, hideSidePanel, isToggled, contentStyle, style } = props;

  return (
    <>
      <div
        id="side-panel"
        className={className}
        style={style}
        onDoubleClick={props.onDoubleClick}
        {...getWidgetDataAttributes("sidePanel", "Side panel")}
      >
        {isToggled && (
          <div className="close-panel" onClick={hideSidePanel}>
            <i className="far fa-close" />
          </div>
        )}

        <div className={contentClassName} style={contentStyle}>
          <Logo />
          <Menu />
          <SocialIcons />
          <UserLogin />
        </div>
      </div>

      <div className={classnames("side-panel-overlay", { visible: isToggled })} />
    </>
  );
};

export default withIsVisibleHOC(
  withClickOutsideHOC<Props>(
    SidePanel,
    (props: Props) => props.hideSidePanel,
    (props: Props) => props.isToggled
  )
);
